// components/UIButton.js
import React from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./UIButton.css";

export default function UIButton({
    as: Component = "button",  // default root element
    children,
    variant = "primary",
    size = "medium",
    disabled = false,
    width,
    className = "",
    ...rest
}) {
    const styleOverride = width ? { width } : {};

    const classes = classNames("ui-btn", variant, size, { disabled }, className);

    // If Component is not "button", render a non-button element
    if (Component !== "button") {
        return (
            <Component
                {...rest}
                className={classes}
                aria-disabled={disabled || undefined}
                style={styleOverride}
                role="button"
                tabIndex={0}
            >
                {children}
            </Component>
        );
    }

    // Default button mode (safe outside tree)
    return (
        <Button
            {...rest}
            disabled={disabled}
            color=""
            className={classes}
            style={styleOverride}
        >
            {children}
        </Button>
    );
}


UIButton.propTypes = {
    as: PropTypes.elementType,
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf([
        "primary",
        "danger",
        "info",
        "success",
        "cancel",
        "submit",
    ]),
    size: PropTypes.oneOf(["large", "medium", "small"]),
    disabled: PropTypes.bool,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // e.g. "200px" or 200
};
